<template>
    <div>
        <div class="card">
            <div class="card__header">
				<h4 class="card__title">Денежные переводы</h4>
            </div>
            <div class="card__body">
				<nav class="fields__item nav-line">
					<router-link :to="{name: 'revshare'}" class="nav-line__item">RevShare</router-link>
					<router-link :to="{name: 'promocodes'}" class="nav-line__item">Промокоды</router-link>
					<a class="nav-line__item active"
					   v-if="user && (user.is_admin || user.can_transfer)">
						Переводы
					</a>
					<router-link
						v-if="user && (user.is_admin || user.max_loan)"
						:to="{name: 'loan'}" class="nav-line__item">
						Кредит
					</router-link>
				</nav>

				<div class="fields__item">
					<div class="fields__row">
						<div class="fields__col">
							<div class="fields__item">
								<div class="text-field__label">Укажите сумму перевода, максимальная сумма 5000 рублей.</div>
								<input v-model="data.amount" class="text-field__input" type="text" placeholder="Сумма">
							</div>
							<div class="fields__item">
								<div class="text-field__label">Укажите пожалуйста ID получателя или имя пользователя</div>
								<input v-model="data.user" class="text-field__input" type="text" placeholder="ID или username пользователя">
							</div>
							<div class="fields__item">
								<div class="text-field__label">Дополнительная информация к переводу</div>
								<input v-model="data.comment" class="text-field__input" type="text" placeholder="Комментарий">
							</div>
							<div class="alert alert--danger" v-if="error.show">
								{{ error.message }}
							</div>
							<div class="alert alert--success" v-if="success.show">
								{{ success.message }}
							</div>
							<button
								@click="transfer()"
								:disabled="disableButton"
								type="submit" class="btn btn--primary">
								Перевести
							</button>
						</div>
						<div class="fields__col">
							<div class="table-wrap" v-if="Object.keys(transfers).length">
								<table class="table table--bordered">
									<thead>
										<tr>
											<th>Пользователь</th>
											<th>Сумма</th>
											<th>Дата</th>
										</tr>
									</thead>
									<tbody>
									<tr v-for="(transfer) in transfers">
										<td>
											<span v-if="!transfer.sender"
												  class="badge badge--success-light">
												<svg height="14px" width="14px">
													<use href="#svg-icon-arrow-down"></use>
												</svg>
											</span>
											<span v-if="transfer.sender"
												  class="badge badge--danger-light text-danger">
												<svg height="14px" width="14px">
													<use href="#svg-icon-arrow-up"></use>
												</svg>
											</span>

											{{ transfer.sender ? transfer.to.username : transfer.from.username }}
											<small v-if="transfer.comment" class="text-muted">
												{{ transfer.comment }}
											</small>
										</td>
										<td>{{ Number(transfer.amount).toFixed(2) }} ₽</td>
										<td>{{ transfer.datetime }}</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div class="text-center" v-else>
								<h4>Вы ещё не произвели ни одного перевода</h4>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';

    export default {
        data() {
            return {
                transfers: [],
                data: {
                    amount: 0,
                    user: null,
                    comment: null
                },
                isValid: true,
                error: {
                    show: false,
                    message: ''
                },
                success: {
                    show: false,
                    message: ''
                },
                disableButton: false
            }
        },
		computed: {
			...mapState(useUserStore, ['user']),
		},
        mounted() {
            this.$root.isLoading = true;

            if(!this.$cookie.get('token')) {
                this.$root.isLoading = false;
                this.$router.go(-1);
            }

            this.get();
        },
        methods: {
            validate() {
                this.isValid = true;
                this.disableButton = true;
                this.data.amount = Number(this.data.amount).toFixed(2);

                if(isNaN(this.data.amount) || this.data.amount > 5000 || this.data.amount < 10) {
                    this.isValid = false;
                    this.$toast.error('Введите сумму от 10 до 5000');
                }

                if(this.data.user === '') {
                    this.isValid = false;
                    this.$toast.error('Укажите пожалуйста ID получателя или имя пользователя');
                }

                this.disableButton = false;

                return this.isValid;
            },
            get() {
                this.$root.axios.get('/api/transfers')
                .then(res => {
                    this.transfers = res.data.transfers;
                    this.$root.isLoading = false;
                });
            },
            transfer() {
                if(!this.validate()) return;

                this.$root.axios.post('/api/transfers/send', this.data)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.user.balance = res.data.balance;

                    this.get();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
        }
    }
</script>
